import {ReactElement, useState} from "react";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import Grid from "@mui/material/Grid";
import Title from "../../components/Title";
import {CashDividend} from "../../domain/dividend/CashDividend";
import {PageDto} from "../../domain/PageDto";
import CashDividendsSearchComponent from "../../components/CashDividendSearchComponent";
import {SearchDataFunction} from "../../components/types/SearchDataFunction";
import {useSearchCashDividends} from "../../application/CashDividendService";
import {CashDividendSearchTerm} from "../../domain/dividend/CashDividendSearchTerm";
import CashDividendSearchBar, {CashDividendSearchFields} from "../../components/CashDividendSearchBar";
import {Collapse} from "@mui/material";


export default function SearchCashDividendsPage(): ReactElement {

    const dividends: SearchDataFunction<CashDividendSearchTerm, PageDto<CashDividend>> = useSearchCashDividends();
    const [ searchExpanded, setSearchExpanded ] = useState<boolean>(false);

    return (
        <Container maxWidth={ false } sx={{ mt: 4, mb: 4 }}>
            { <Toolbar/> }
            <Grid
                container
                spacing={2}
                sx={{
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 2
                }}>
                <Grid size={{ xs: 12, md: 10, lg: 10 }}>
                    <Title>All Dividends</Title>
                </Grid>
                <CashDividendSearchBar searchFn={ dividends } expanded={searchExpanded} onToggle={setSearchExpanded}/>
            </Grid>
            <Collapse in={searchExpanded} timeout="auto" unmountOnExit>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid size={{ xs: 12, md: 12, lg: 12 }}>
                        <CashDividendSearchFields searchFn={ dividends }/>
                    </Grid>
                </Grid>
            </Collapse>
            <Grid container spacing={2}>
                <CashDividendsSearchComponent apiFunction={ dividends }/>
            </Grid>
        </Container>
    );
}